import axios from '../../../core/services/axios';

// eslint-disable-next-line import/prefer-default-export
export const getLabels = (params) => axios.get('/api/user-labels/', {
  params,
});

export const deleteLabel = (id) => axios.delete(`/api/user-labels/${id}`);
